module.exports = __webpack_public_path__ + "static/media/chat.b622af4d.svg";